import { render, staticRenderFns } from "./CableManagement.vue?vue&type=template&id=20021608&scoped=true"
import script from "./CableManagement.vue?vue&type=script&lang=js"
export * from "./CableManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20021608",
  null
  
)

export default component.exports